package songwritersnotebook.app.screens.components

import songwritersnotebook.app.screens.*

import androidx.compose.animation.AnimatedContent
import androidx.compose.animation.AnimatedVisibility
import androidx.compose.animation.fadeIn
import androidx.compose.animation.fadeOut
import androidx.compose.animation.slideInVertically
import androidx.compose.animation.slideOutVertically
import androidx.compose.animation.togetherWith
import androidx.compose.animation.core.animateFloat
import androidx.compose.animation.core.animateFloatAsState
import androidx.compose.animation.core.rememberInfiniteTransition
import androidx.compose.animation.core.infiniteRepeatable
import androidx.compose.animation.core.tween
import androidx.compose.animation.core.RepeatMode
import androidx.compose.animation.core.LinearEasing
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.font.FontStyle
import androidx.compose.ui.platform.LocalDensity
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.TextRange
import androidx.compose.ui.text.TextLayoutResult
import androidx.compose.ui.text.input.TextFieldValue
import androidx.compose.ui.text.input.KeyboardCapitalization
import kotlinx.coroutines.delay
import kotlinx.coroutines.withTimeoutOrNull
import androidx.compose.foundation.gestures.awaitEachGesture
import androidx.compose.foundation.gestures.awaitFirstDown
import androidx.compose.foundation.gestures.waitForUpOrCancellation
import androidx.compose.ui.draw.drawWithContent
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.geometry.Size
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.gestures.detectTapGestures
import androidx.compose.foundation.gestures.detectHorizontalDragGestures
import androidx.compose.ui.focus.FocusRequester
import androidx.compose.ui.focus.focusRequester
import androidx.compose.ui.focus.onFocusChanged
import androidx.compose.ui.input.pointer.pointerInput
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.itemsIndexed
import androidx.compose.foundation.horizontalScroll
import androidx.compose.foundation.rememberScrollState
import songwritersnotebook.app.utils.NetworkUtils
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.BasicTextField
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.foundation.text.KeyboardActions
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.automirrored.filled.ArrowBack
import androidx.compose.material.icons.automirrored.filled.MenuBook
import androidx.compose.material.icons.automirrored.filled.Send
import androidx.compose.material.icons.automirrored.filled.Undo
import androidx.compose.material.icons.automirrored.filled.Redo
import androidx.compose.material.icons.filled.*
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.alpha
import androidx.compose.ui.draw.clip
import androidx.compose.ui.draw.scale
import androidx.compose.ui.zIndex
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.graphics.BlendMode
import androidx.compose.ui.graphics.graphicsLayer
import androidx.compose.ui.text.font.FontFamily
import androidx.compose.ui.unit.DpSize
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.material.icons.filled.CloudDone
import androidx.compose.material.icons.filled.Save
import androidx.compose.material.icons.filled.Piano
import androidx.compose.material.icons.filled.Check
import songwritersnotebook.app.utils.rememberMicPermissionLauncher
import androidx.compose.material.icons.filled.Edit
import androidx.compose.material.icons.filled.Delete
import androidx.compose.material.icons.filled.MusicNote
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.ExperimentalLayoutApi
import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.lazy.LazyRow
import androidx.compose.foundation.lazy.items
import androidx.compose.ui.platform.LocalSoftwareKeyboardController
import androidx.compose.ui.window.Dialog
import androidx.compose.ui.window.DialogProperties
import androidx.compose.ui.text.input.ImeAction
import androidx.compose.foundation.lazy.rememberLazyListState
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.geometry.CornerRadius
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import songwritersnotebook.app.billing.SubscriptionTier
import songwritersnotebook.app.billing.ProductInfo
import songwritersnotebook.app.data.*
import songwritersnotebook.app.navigation.AppRoutes
import songwritersnotebook.app.ui.theme.BlueAccent
import songwritersnotebook.app.ui.theme.GoldAccent
import songwritersnotebook.app.ui.theme.SliderThumbGray
import songwritersnotebook.app.ui.theme.SliderTrackGray
import songwritersnotebook.app.ui.theme.ChordVisualTransformation
import songwritersnotebook.app.utils.countSyllables
import songwritersnotebook.app.viewmodels.*
import kotlinx.datetime.*
import org.jetbrains.compose.resources.painterResource
import songwritersnotebookapp.composeapp.generated.resources.Res
import songwritersnotebookapp.composeapp.generated.resources.ic_guitar
import songwritersnotebook.app.ui.theme.SuccessGreen
import songwritersnotebook.app.components.SaveStatusIndicator
import songwritersnotebook.app.adaptiveSheetWidth
import songwritersnotebook.app.components.ChordPanel
import songwritersnotebook.app.components.ChordCreatorSheet
import songwritersnotebook.app.components.HarmonyAiTabContent
import songwritersnotebook.app.components.TabEditorSheet
import songwritersnotebook.app.components.RecordingSheet
import songwritersnotebook.app.components.LineMediaSheet
import songwritersnotebook.app.components.TabDisplay
import songwritersnotebook.app.components.LoadingOverlay
import songwritersnotebook.app.tutorial.TutorialManager
import songwritersnotebook.app.tutorial.TutorialStep
import songwritersnotebook.app.tutorial.tutorialTarget
import androidx.compose.material3.SegmentedButton
import androidx.compose.material3.SegmentedButtonDefaults
import androidx.compose.material3.SingleChoiceSegmentedButtonRow
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.verticalScroll
import androidx.compose.foundation.rememberScrollState
import songwritersnotebook.app.tutorial.TutorialOverlay
import songwritersnotebook.app.LocalPlatformContext
import androidx.compose.ui.input.key.onPreviewKeyEvent
import androidx.compose.ui.input.key.Key
import androidx.compose.ui.input.key.key
import androidx.compose.ui.input.key.type
import androidx.compose.ui.input.key.KeyEventType
import androidx.compose.ui.unit.IntOffset
import songwritersnotebook.app.components.VersionHistorySheet
import songwritersnotebook.app.components.MetronomeSettingItem


@Composable
fun EditorSettingsSheetContent(
    settings: EditorSettings,
    viewModel: EditorViewModel,
    tempBpm: Int,
    onTempBpmChange: (Int) -> Unit,
    onTempBpmChangeFinished: () -> Unit,
    onShowVersionHistory: () -> Unit,
    onDoneEditing: () -> Unit = {}
) {
    Column(
        modifier = Modifier
            .padding(8.dp)
            .navigationBarsPadding()
            .verticalScroll(rememberScrollState())
    ) {
        Box(modifier = Modifier.fillMaxWidth(), contentAlignment = Alignment.Center) {
            Box(
                modifier = Modifier
                    .width(40.dp)
                    .height(4.dp)
                    .background(MaterialTheme.colorScheme.outline, CircleShape)
            )
        }
        Spacer(modifier = Modifier.height(16.dp))

        // Song Notes Section
        val uiState by viewModel.uiState.collectAsState()
        val song = uiState.song
        var showNotesEditor by remember { mutableStateOf(false) }

        if (showNotesEditor) {
            SongNotesDialog(
                initialNotes = song?.notes ?: "",
                onDismiss = { showNotesEditor = false },
                onSave = { 
                    viewModel.updateNotes(it)
                    showNotesEditor = false
                }
            )
        }

        Card(
            modifier = Modifier.fillMaxWidth(),
            shape = RoundedCornerShape(12.dp),
            border = BorderStroke(1.dp, MaterialTheme.colorScheme.outlineVariant.copy(alpha = 0.5f))
        ) {
            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(horizontal = 16.dp, vertical = 8.dp),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.SpaceBetween
            ) {
                Row(verticalAlignment = Alignment.CenterVertically, modifier = Modifier.weight(1f)) {
                    Icon(Icons.Default.Description, contentDescription = null, tint = MaterialTheme.colorScheme.primary)
                    Spacer(Modifier.width(12.dp))
                    Text("Song Notes", style = MaterialTheme.typography.bodyLarge, fontWeight = FontWeight.Bold)
                }
                
                Row(verticalAlignment = Alignment.CenterVertically) {
                    TextButton(onClick = { showNotesEditor = true }) {
                        Text(if ((song?.notes ?: "").isBlank()) "Add" else "Edit")
                    }
                    Spacer(Modifier.width(8.dp))
                    Switch(
                        checked = song?.showNotes ?: false,
                        onCheckedChange = { viewModel.toggleShowNotes() },
                        modifier = Modifier.scale(0.8f)
                    )
                }
            }
        }

        Spacer(modifier = Modifier.height(16.dp))

        // Version History Section
        Card(
            modifier = Modifier.fillMaxWidth(),
            shape = RoundedCornerShape(12.dp),
            border = BorderStroke(1.dp, MaterialTheme.colorScheme.outlineVariant.copy(alpha = 0.5f))
        ) {
            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .clickable { onShowVersionHistory() }
                    .padding(horizontal = 16.dp, vertical = 12.dp),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.SpaceBetween
            ) {
                Row(verticalAlignment = Alignment.CenterVertically) {
                    Icon(Icons.Default.History, contentDescription = null, tint = MaterialTheme.colorScheme.primary)
                    Spacer(Modifier.width(12.dp))
                    Text("Version History", style = MaterialTheme.typography.bodyLarge, fontWeight = FontWeight.Bold)
                }
                Icon(Icons.Default.ChevronRight, contentDescription = null, tint = MaterialTheme.colorScheme.onSurfaceVariant)
            }
        }

        Spacer(modifier = Modifier.height(16.dp))

        Card(
            modifier = Modifier.fillMaxWidth(),
            shape = RoundedCornerShape(12.dp),
            border = BorderStroke(1.dp, MaterialTheme.colorScheme.outlineVariant.copy(alpha = 0.5f))
        ) {
            Column(modifier = Modifier.padding(vertical = 8.dp)) {
                MetronomeSettingItem(
                    label = "Tempo",
                    bpm = tempBpm,
                    onBpmChange = onTempBpmChange,
                    isPreviewActive = uiState.isTempoPreviewActive,
                    onPreviewToggle = { viewModel.toggleTempoPreview() },
                    isMuted = uiState.isMetronomeMuted,
                    onMutedChange = { viewModel.toggleMetronomeMuted() },
                    currentBeat = uiState.currentMetronomeBeat,
                    showDivider = true,
                    onBpmChangeFinished = onTempBpmChangeFinished
                )


                
                SettingSwitchItem(
                    label = "Show Section Headers",
                    checked = settings.showSectionHeaders,
                    onToggle = { viewModel.toggleShowSectionHeaders() }
                )
                SettingSegmentedButtonItem(
                    label = "Chord Display",
                    selected = settings.chordDisplay,
                    onSelect = { viewModel.setChordDisplayMode(it) }
                )
                
                AnimatedVisibility(visible = settings.chordDisplay != ChordDisplayMode.Off) {
                    SettingPlacementSegmentedButtonItem(
                        label = "Chord Placement",
                        selected = settings.chordPlacement,
                        onSelect = { viewModel.setChordPlacement(it) }
                    )
                }
                SettingSwitchItem(
                    label = "Syllable Count",
                    checked = settings.syllableCountEnabled,
                    onToggle = { viewModel.toggleSyllableCount() },
                    showDivider = false
                )
            }
        }

        Spacer(modifier = Modifier.height(16.dp))

        Card(
            modifier = Modifier.fillMaxWidth(),
            shape = RoundedCornerShape(12.dp),
            border = BorderStroke(1.dp, MaterialTheme.colorScheme.outlineVariant.copy(alpha = 0.5f))
        ) {
            Column(modifier = Modifier.padding(vertical = 8.dp)) {
                SettingSwitchItem(
                    label = "Rhyming",
                    checked = settings.rhymingEnabled,
                    onToggle = { viewModel.toggleRhyming() }
                )
                AnimatedVisibility(visible = settings.rhymingEnabled) {
                    Column(modifier = Modifier.padding(start = 16.dp)) {
                        SettingSwitchItem(
                            label = "Show Slant Rhymes",
                            checked = settings.showSlantRhymes,
                            onToggle = { viewModel.toggleSlantRhymes() }
                        )
                        SettingSwitchItem(
                            label = "End of Line Only",
                            checked = settings.endOfLineOnly,
                            onToggle = { viewModel.toggleEndOfLineOnly() },
                            showDivider = false
                        )
                    }
                }
            }
        }
        Spacer(modifier = Modifier.height(8.dp))

        Card(
            modifier = Modifier.fillMaxWidth(),
            shape = RoundedCornerShape(12.dp),
            border = BorderStroke(1.dp, MaterialTheme.colorScheme.outlineVariant.copy(alpha = 0.5f))
        ) {
            Column(modifier = Modifier.padding(vertical = 8.dp)) {
                SettingSwitchItem(label = "Show Piano Info", checked = settings.showPianoInfo, onToggle = { viewModel.toggleShowPianoInfo() })
                SettingSwitchItem(label = "Show Guitar Info", checked = settings.showGuitarInfo, onToggle = { viewModel.toggleShowGuitarInfo() })
                SettingSwitchItem(
                    label = "Show Tabs",
                    checked = settings.showTabs,
                    onToggle = { viewModel.toggleShowTabs() },
                    showDivider = false
                )
            }
        }

        // PRO SELF-HEALING: Only available to STUDIO Owners for synced songs
        val currentUserId = viewModel.currentUserId
        val isOwner = song?.ownerId == currentUserId
        val isStudio = uiState.userProfile?.subscriptionTier == "STUDIO"
        val hasCloudCopy = (song?.lastSynced != null)

        if (isStudio && isOwner && hasCloudCopy) {
            Spacer(modifier = Modifier.height(24.dp))
            
            var showRepairDialog by remember { mutableStateOf(false) }

            if (showRepairDialog) {
                AlertDialog(
                    onDismissRequest = { showRepairDialog = false },
                    title = { Text("Repair Song?") },
                    text = { Text("This will clear your local state and force a fresh download from the cloud. Use this only if your song appears corrupted or isn't syncing correctly. You will lose any unsaved local changes.") },
                    confirmButton = {
                        Button(
                            onClick = {
                                showRepairDialog = false
                                viewModel.repairCurrentSong { success ->
                                    songwritersnotebook.app.utils.PlatformToast.show(
                                        if (success) "Song repaired successfully!" else "Repair failed. Please ensure you are online."
                                    )
                                }
                            },
                            colors = ButtonDefaults.buttonColors(containerColor = MaterialTheme.colorScheme.error)
                        ) {
                            Text("Repair Now")
                        }
                    },
                    dismissButton = {
                        TextButton(onClick = { showRepairDialog = false }) {
                            Text("Cancel")
                        }
                    }
                )
            }

            Text("ADVANCED TOOLS", style = MaterialTheme.typography.labelSmall, color = MaterialTheme.colorScheme.error, modifier = Modifier.padding(bottom = 8.dp, start = 8.dp))
            Card(
                modifier = Modifier.fillMaxWidth(),
                shape = RoundedCornerShape(12.dp),
                border = BorderStroke(1.dp, MaterialTheme.colorScheme.error.copy(alpha = 0.3f)),
                colors = CardDefaults.cardColors(containerColor = MaterialTheme.colorScheme.errorContainer.copy(alpha = 0.1f))
            ) {
                Row(
                    modifier = Modifier
                        .fillMaxWidth()
                        .clickable { showRepairDialog = true }
                        .padding(horizontal = 16.dp, vertical = 12.dp),
                    verticalAlignment = Alignment.CenterVertically,
                    horizontalArrangement = Arrangement.SpaceBetween
                ) {
                    Row(verticalAlignment = Alignment.CenterVertically) {
                        Icon(Icons.Default.Build, contentDescription = null, tint = MaterialTheme.colorScheme.error)
                        Spacer(Modifier.width(12.dp))
                        Text("Repair Song", style = MaterialTheme.typography.bodyLarge, color = MaterialTheme.colorScheme.error, fontWeight = FontWeight.Bold)
                    }
                    Icon(Icons.Default.ChevronRight, contentDescription = null, tint = MaterialTheme.colorScheme.error.copy(alpha = 0.5f))
                }
            }
        }
    }
}


@Composable
fun SettingSwitchItem(
    label: String,
    checked: Boolean,
    onToggle: () -> Unit,
    showDivider: Boolean = true,
    enabled: Boolean = true
) {
    Column {
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .clickable(enabled = enabled) { onToggle() }
                .padding(horizontal = 16.dp, vertical = 8.dp),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.SpaceBetween
        ) {
            Text(
                text = label, 
                style = MaterialTheme.typography.bodyMedium,
                color = if (enabled) MaterialTheme.colorScheme.onSurface else MaterialTheme.colorScheme.onSurface.copy(alpha = 0.38f)
            )
            Switch(
                checked = checked, 
                onCheckedChange = { onToggle() }, 
                modifier = Modifier.height(24.dp),
                enabled = enabled
            )
        }
        if (showDivider) {
            HorizontalDivider(color = MaterialTheme.colorScheme.onSurface.copy(alpha = 0.1f), modifier = Modifier.padding(horizontal = 16.dp))
        }
    }
}

@OptIn(ExperimentalMaterial3Api::class)

@Composable
fun SettingSegmentedButtonItem(
    label: String,
    selected: ChordDisplayMode,
    onSelect: (ChordDisplayMode) -> Unit
) {
    Column {
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .padding(horizontal = 16.dp, vertical = 12.dp),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.SpaceBetween
        ) {
            Text(label, style = MaterialTheme.typography.bodyMedium)
            SingleChoiceSegmentedButtonRow {
                ChordDisplayMode.entries.forEachIndexed { index, mode ->
                    SegmentedButton(
                        selected = selected == mode,
                        onClick = { onSelect(mode) },
                        shape = SegmentedButtonDefaults.itemShape(index = index, count = ChordDisplayMode.entries.size),
                        label = { Text(mode.name.lowercase().replaceFirstChar { if (it.isLowerCase()) it.titlecase() else it.toString() }) }
                    )
                }
            }
        }
        HorizontalDivider(color = MaterialTheme.colorScheme.onSurface.copy(alpha = 0.1f), modifier = Modifier.padding(horizontal = 16.dp))
    }
}

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun SettingPlacementSegmentedButtonItem(
    label: String,
    selected: ChordPlacement,
    onSelect: (ChordPlacement) -> Unit
) {
    Column {
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .padding(horizontal = 16.dp, vertical = 12.dp),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.SpaceBetween
        ) {
            Text(label, style = MaterialTheme.typography.bodyMedium)
            SingleChoiceSegmentedButtonRow {
                ChordPlacement.entries.forEachIndexed { index, mode ->
                    SegmentedButton(
                        selected = selected == mode,
                        onClick = { onSelect(mode) },
                        shape = SegmentedButtonDefaults.itemShape(index = index, count = ChordPlacement.entries.size),
                        label = { Text(mode.name.lowercase().replaceFirstChar { if (it.isLowerCase()) it.titlecase() else it.toString() }) }
                    )
                }
            }
        }
        HorizontalDivider(color = MaterialTheme.colorScheme.onSurface.copy(alpha = 0.1f), modifier = Modifier.padding(horizontal = 16.dp))
    }
}


@Composable
fun SettingTextFieldItem(
    label: String,
    value: String,
    onValueChange: (String) -> Unit,
    showDivider: Boolean = true,
    onDone: (() -> Unit)? = null
) {
    val focusManager = androidx.compose.ui.platform.LocalFocusManager.current
    Column {
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .padding(horizontal = 16.dp, vertical = 8.dp),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.SpaceBetween
        ) {
            Text(label, style = MaterialTheme.typography.bodyMedium)
            OutlinedTextField(
                value = value,
                onValueChange = onValueChange,
                modifier = Modifier.width(80.dp),
                textStyle = TextStyle(textAlign = TextAlign.Center),
                keyboardOptions = KeyboardOptions(
                    keyboardType = KeyboardType.Number,
                    imeAction = if (onDone != null) androidx.compose.ui.text.input.ImeAction.Done else androidx.compose.ui.text.input.ImeAction.Default
                ),
                keyboardActions = KeyboardActions(
                    onDone = {
                        focusManager.clearFocus()
                        onDone?.invoke()
                    }
                ),
                singleLine = true
            )
        }
        if (showDivider) {
            HorizontalDivider(
                color = MaterialTheme.colorScheme.onSurface.copy(alpha = 0.1f),
                modifier = Modifier.padding(horizontal = 16.dp)
            )
        }
    }
}


